import React from 'react';
import { ZoomWrapper } from "../..";
import { ImageContainer, Image } from '../style';
import { Magnetic as Mi } from "../../../styles";
const getEarmarkStyle = (carouselItem) => {
    return carouselItem.tagId ? { paddingTop: `${Mi.spacer48}` } : undefined;
};
/**
 *
 * @param props ICarouselItemTypeProps
 * @returns ImageZoomedView - component
 */
export const ImageZoomedView = (props) => {
    const { file, index, zoomScale, setZoomScale, showZoomIcon } = props.carouselViewProps;
    return (React.createElement(ImageContainer, { id: `image-container-${index}` },
        React.createElement(ZoomWrapper, { id: `zoom-wrapper-${index}`, scale: zoomScale, onZoomChange: setZoomScale, style: getEarmarkStyle(file), showZoomIcon: showZoomIcon },
            React.createElement(Image, { id: `original-image-${index}`, src: file.url }))));
};
//# sourceMappingURL=ImageZoomedView.js.map